{
  "title": "لمحة عامة",
  "cards": {
    "users": "عدد المستخدمين",
    "debtors": "عدد عملاء الذمم",
    "revolvingBalances": "الأرصدة المدورة",
    "purchases": "المشتريات",
    "sales": "المبيعات",
    "debtSales": "مبيعات الذمم",
    "payments": "المدفوعات",
    "receipts": "المقبوضات"
  },
  "products": {
    "DIESEL": "محروقات",
    "PETROL": "بنزين"
  },
  "branchFilter": "الفرع",
  "empty": {
    "noProducts": "لا يوجد منتج متاح لهذا المستخدم"
  },
  "lock": {
    "label": "كلمة المرور",
    "submit": "عرض الإحصائيات",
    "hint": "أدخل كلمة مرور لمحة عامة لعرض الإحصائيات",
    "required": "كلمة المرور مطلوبة",
    "notSetLink": "الأسعار والإعدادات",
    "logoAlt": "المسافر"
  }
}
